<template>
  <div>
    <MainHeader>
      <div class="lg:flex lg:items-center lg:justify-between">
        <!-- Left side -->
        <div class="flex-1 min-w-0">
          <div class="flex items-center pr-4 sm:truncate">
            <h1
              class="text-2xl font-bold leading-7 text-cool-gray-900 sm:leading-9"
            >
              <span>
                Gift Cards
              </span>
            </h1>
          </div>
        </div>
      </div>
    </MainHeader>

    <SearchGiftCards class="max-w-6xl mx-auto mt-32" />
  </div>
</template>
<script>
import MainHeader from "@/components/elements/MainHeader.vue";
import SearchGiftCards from "./components/SearchGiftCards.vue";

export default {
  name: "GiftCards",
  components: {
    MainHeader,
    SearchGiftCards
  },
};
</script>
